import React from 'react';
import { useParams } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SnippetDisplay from './SnippetDisplay';

// Component for listing code snippets
function Snippets({ snippets, documentationURL }) {
    const { language } = useParams();  // Get language from the URL

    return (
        <Row className="mt-4 text-center">
            <Col xs="12" md="6" className="mx-auto">
                <h2>{language ? `Snippets for ${language}` : 'Search result'}</h2>
                {documentationURL && (
                    <a href={documentationURL} target="_blank" rel="noopener noreferrer">
                        Official documentation
                    </a>
                )}
                <SnippetDisplay snippets={snippets} />
            </Col>
        </Row>
    );
}  

export default Snippets;